/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./SelectOffice.module.css";

const NavigationButtons: React.FC = () => {
  return (
    <div className={styles.navigationButtons}>
      <button className={styles.navButton}>
        <span className={styles.navButtonContent}>Previous</span>
      </button>
      <button className={styles.navButton}>
        <span className={styles.navButtonContent}>Next</span>
      </button>
    </div>
  );
};

export default NavigationButtons;
